import { PhoneNumberModel } from "./phone.model";
import { WhatsappModel } from "./whatsapp.model";

export class ContactModel {

  phone: PhoneNumberModel
  email: string
  whatsapp: WhatsappModel;

  constructor(obj: any = null) {
    this.phone = new WhatsappModel(obj?.phone) 
    this.email = obj?.email
    this.whatsapp = new WhatsappModel(obj?.whatsapp)  
  }
}
